/* global angular _*/
import { keyBy, orderBy } from 'lodash';

export default function($log, $stateParams, $q, $timeout, ApiClass, RegulatorClass, CategoryClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.certsHeaders = [
    { title: 'Date Issued', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2', default: 'reverse' },
    { title: 'Certificate Name', class: 'col-lg-4 col-md-4 col-sm-4 col-xs-4' },
    { title: 'Subject Area', class: 'col-lg-3 col-md-3 col-sm-3 col-xs-3' },
    { title: 'Credits', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1' },
    { title: 'Delivery Method', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' }
  ];

  vm.regColorDict = {
    Technical: 'warning',
    'Accounting Auditing Tax': 'success',
    Tax: 'success',
    'Accounting Auditing': 'warning',
    'Non-Technical': 'success',
    'Personal Development': 'warning',
    'General Ethics': 'info',
    'State Ethics': 'info',
    'General Hours': 'success',
    Fraud: 'primary',
    'Regulatory Review': 'danger'
  };

  vm.setActive = (regulatorKey, yearIndex = 0) => {
    if (regulatorKey) vm.activeTab = regulatorKey;

    if (!vm.activeTab) {
      regulatorKey = Object.keys(vm.flatCompObj).sort()[0];
      vm.activeTab = regulatorKey;
    }

    vm.activeYearIndex = yearIndex;
    vm.activeCompliance = vm.flatCompObj[regulatorKey][yearIndex];
  };

  vm.deliveriesArr = [
    'Self-Study',
    'Live Course',
    'Webinar',
    'Publication',
    'Instruction',
    'University',
    'Self-Study (Non-Interactive)',
    'Carry Over',
    'QAS Self-Study'
  ];

  function activate() {
    $log.debug('Detailed Compliance Breakdown Component Activated');
    vm.error = {};
    vm.profileUid = $stateParams.employeeID || $stateParams.id;
    vm.licenseObj = {};
    vm.licenseActiveArr = [];

    const qArr = [
      RegulatorClass.loadRegulators(),
      CategoryClass.loadCategories(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:flatcompliance': true,
            'include:certificates': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(
        ([
          { arr: regulators, obj: regulatorsDict },
          { arr: categories, obj: categoriesDict },
          {
            data: { flatcompliance, certificates }
          }
        ]) => {
          $log.debug('Detailed Compliance Breakdown Componen Data', arguments);

          // TODO refactor to use vm.regulatorTimeDict
          vm.regulatorDict = keyBy(regulators, 'reg_id');

          vm.compArr = flatcompliance;
          vm.certs = certificates;
          vm.certsDict = keyBy(certificates, 'cert_id');
          vm.certCategoryDict = categoriesDict;
          vm.regulatorTimeDict = regulatorsDict;

          if (!vm.compArr.length) return (vm.loaded = true);

          vm.gaugesDict = regulators.reduce((obj, regulator) => {
            if (!obj.hasOwnProperty(regulator.reg_id)) obj[regulator.reg_id] = {};
            if (!obj[regulator.reg_id].hasOwnProperty('name')) obj[regulator.reg_id].name = regulator.name;
            obj[regulator.reg_id][regulator.date] = keyBy(regulator.gauges, 'value');
            return obj;
          }, {});

          vm.flatCompObj = flatcompliance.reduce((obj, item) => {
            if (!obj[item.reg_id]) obj[item.reg_id] = [];
            if (item.cycle_date) item.sortTime = new Date(item.cycle_date).getTime();
            const { cycle_limiter, cycle_total, cycle } = regulatorsDict[item.reg_id][item.reg_date];

            if (!('cycle_limiter' in item)) item.cycle_limiter = cycle_limiter;
            if ('cycle' in item.cycle_limiter) item.cycle = item.cycle_limiter.cycle;
            if ('prorate_cycle' in item.cycle_limiter) item.cycle = item.cycle_limiter.prorate_cycle;
            if (!('cycle' in item)) item.cycle = cycle;
            if (!('cycle_total' in item.cycle_limiter)) item.cycle_limiter.cycle_total = cycle_total;

            obj[item.reg_id] = orderBy([...obj[item.reg_id], item], ['sortTime'], ['desc']);
            obj[item.reg_id].name = vm.regulatorTimeDict[item.reg_id].name;
            obj[item.reg_id].key = item.reg_id;

            return obj;
          }, {});

          vm.setActive();
          vm.loaded = true;
        }
      )
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };

        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/detailedComplianceBreakdown/controller.js